<template>
  <div>
    <!-- nav -->
    <search-nav @handleSearch="onClickSearch">
      <div class="search-layout w-full grid col-gap-4 flex-wrap xl:flex ">
        <component
          v-for="(component, index) in stdSearchComponents"
          v-if="showSearchNavItem(component['options'])"
          :is="component['component']"
          :label="component['label']"
          :query="component['query']"
          :options="component['options']"
          :onClickSearch="onClickSearch"
          v-model="nav.value[component['value']]"
        />
      </div>
    </search-nav>

    <!-- 목록-->
    <div class="w-full">
      <div class="w-full overflow-x-auto">
        <table class="w-full mt-4">
          <colgroup>
            <col width="160px"/>
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col width="100px"/>
          </colgroup>
          <thead>
            <tr>
              <th><div style="min-width: 160px;">대상년도</div></th>
              <th><div>사업장명</div></th>
              <th><div>법령</div></th>
              <th><div>구분</div></th>
              <th><div>선임일</div></th>
              <th><div>이름</div></th>
              <th><div>최근 교육일</div></th>
              <th><div>차기 교육일</div></th>
              <th><div style="min-width: 100px;">이수증</div></th>
            </tr>
          </thead>
          <tbody>

            <tr v-for="row in list">
              <td>{{ row.대상년도 }}</td>
              <td>{{ row.사업장명 }}</td>
              <td>{{ row.법령 }}</td>
              <td>{{ row.구분 }}</td>
              <td>{{ row.선임일 }}</td>
              <td>{{ row.이름 }}</td>
              <td>{{ row.최근교육일 }}</td>
              <td>{{ row.차기교육일 }}</td>
              <td>
                <a v-if="row.교육이수증 && row.교육이수증.path" download target="_blank" :href="row.교육이수증.path" @click.stop>
                  <img src="@/assets/images/icon/icon-file.svg" alt="close" class="mx-auto" />
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import singlePageList from "@/views/boards/single-page/listIndex";
import searchComponent from "@/views/list/components/include";
import KPagination from "@/components/kPagination/kPagination.vue";
import SearchNav from "@/components/nav/SearchNav.vue";

export default {
  name: "TableListPage",
  components: {
    KPagination,
    SearchNav,
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    boardId() {
      return this.$route.params.boardId;
    },
    stdSearchComponents() {
      if (singlePageList[`${this.boardId}_list`]) {
        const getComponents = singlePageList[`${this.boardId}_list`].components
        if (getComponents) {
          const stdSearchComponents = getComponents();
          if (stdSearchComponents && stdSearchComponents.length > 0) {
            for (const component of stdSearchComponents) {
              component.component = searchComponent[component['component']];
            }
          }
          return stdSearchComponents;
        }
      }
      return [];
    },

  },
  data () {
    return {
      nav: {
        value: {},
      },
      list: [],

      //pagination
      perPage: 10,
      date: "",
      currentPage: 1,
      lastPage: 1,
      total: 0,
    }
  },
  created() {
    this.loadList();
  },
  methods: {
    async loadList() {
      const conditions = []
      // 대상년도
      const year = this.nav.value.year ? Number(`${this.nav.value.year}`) : new Date().getFullYear();
      conditions.push({ key: "header.year", operator: "=", value: `${year}` });
      // 검색조건
      const heads = singlePageList[`${this.boardId}_list`].getHead().map(e => {return {[e.name] : e.key}});
      // 배열의 객체들을 하나의 객체로 합치기
      const types = Object.assign({}, ...heads);
      if (this.nav.value.column && this.nav.value.column.keyword) {
        conditions.push({key: types[this.nav.value.column.head], operator: 'LIKE', value: `%${this.nav.value.column.keyword}%`})
      }

      const boardIds = [996, 997, 998, 999, 1000];
      const postList = [];
      this.loading(true);
      for (const boardId of boardIds) {
        try {
          const list = await this._loadList(boardId, conditions);
          postList.push(...list);
        } catch (e) {

        }
      }
      this.loading(false);
      this.list = postList.map((value) => {
        const content = JSON.parse(value.post_content)
        return {
          대상년도: content.header.year,
          사업장명: content.body.stdInfo.field_name,
          법령: content.body.subInfo.법령,
          구분: content.body.구분,
          선임일: content.body.subInfo.선임일,
          이름: content.body.subInfo.이름,
          최근교육일: content.body.subInfo.최근교육일,
          차기교육일: content.body.subInfo.차기교육일,
          교육이수증: content.body.subInfo.교육이수증,
        }
      })

      this.list.sort((a, b) => {
        const 사업장명 = ["본사", "인천공장", "포항공장", "당진공장", "중앙기술연구소"]
        const 법령비교 = a.법령.localeCompare(b.법령, 'ko');
        const 구분비교 = a.구분.localeCompare(b.구분, 'ko');
        if (사업장명.indexOf(a.사업장명) === 사업장명.indexOf(b.사업장명)) {
          if (법령비교 === 0) {
            return 구분비교;
          } else {
            return 법령비교;
          }
        }
        return 사업장명.indexOf(a.사업장명) - 사업장명.indexOf(b.사업장명);
      })

    },

    async _loadList(boardId, conditions) {
      const projectId = this.projectId;
      const page = 1;
      const perPage = 50;
      return await this._loadDefragmentation({
        projectId,
        boardId,
        page,
        perPage,
        conditions,
      });
    },
    async _loadDefragmentation(options) {
      const response = await this.$store.dispatch("board/LOAD_POST_LIST", options);
      const list = [];
      list.push(...response.data);
      if (response.current_page !== response.last_page) {
        options.page = response.current_page + 1;
        list.push(... await this._loadDefragmentation(options));
      }
      return list
    },

    onClickSearch () {
      this.loadList()
    },

    showSearchNavItem(options) {
      if (options && options.visibleKeyValue) {
        for (const keyValue of options.visibleKeyValue) {
          const key = Object.keys(keyValue)[0];
          const value = keyValue[key];
          const navValue = this.findJsonDataWithDottedPath(this.nav.value, key);
          if (navValue !== value) {
            if (Array.isArray(navValue) && navValue.toString() === value) {
              return true;
            }
          } else {
            return true;
          }
        }
        return false;
      }
      return true;
    },

    findJsonDataWithDottedPath (json, path) {
      try {
        const _keys = Object.keys(json)
        if (_keys.length === 0) {
          return '';
        }
        const paths = path.split('.')
        let result = json
        for (const p of paths) {
          result = result[p]
        }
        return result
      } catch (err) {
        return ''
      }
    },

    loading(open) {
      const loadingDialog = new CustomEvent("loadingDialog", {
        detail: {
          open,
        },
      });
      window.dispatchEvent(loadingDialog);
    },
  } // methods
}
</script>

<style lang="scss" scoped>
table {
  border-collapse: collapse !important;
  border-spacing: 0 !important;

  thead {
    & th > div {
      white-space: nowrap;
      padding: 10px;
      margin-top: -1px;
      background-color: #f5f5f5;
    }
  }

  th {
    border: 1px solid #e0e0e0;
    text-align: center;

    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }
  td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    text-align: center;
  }
}

.completed {
  color: red;
}
</style>
